import PromoBarModule from './PromoBarModule';

export * from './PromoBarModule';
export default PromoBarModule;
